import { useReducer, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AlertContainer, useAlert } from "./comps/alerts";
import { authReducer, authState, GlobalContext } from "./GlobalContext";
import Auth from "./comps/auth";
import DeAuth from "./comps/deauth";
import Home from "./pages/home";
import Missing from "./pages/missing";
import Loading from "./comps/loading";
import Signin from "./pages/signin";
import Layout from "./comps/layout";
import Dashboard from "./pages/dashboard";
import ClubMember from "./pages/clubmember";
import CreateTeam from "./pages/createteam";
import TeamMember from "./pages/teammember";
import ClubOverview from "./pages/cluboverview";
import PlayerList from "./pages/playerlist";
import PlayerEdit from "./pages/playeredit";
import ClubTeams from "./pages/clubteams";

export default function App() {
  const [alerts, alert] = useAlert();
  const [isLoading, setLoading] = useState(false);
  const [auth, dispatch] = useReducer(authReducer, authState);

  return (
    <GlobalContext.Provider value={{ auth, dispatch, setLoading, alert }}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route element={<DeAuth />}>
              <Route path="/" element={<Home />} />
              <Route path="/signin" element={<Signin />} />
            </Route>

            <Route element={<Auth />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/club-teams/:cid" element={<ClubTeams />} />
              <Route path="/club-member/:cid" element={<ClubMember />} />
              <Route path="/create-team/:cid" element={<CreateTeam />} />
              <Route path="/team-member/:cid/:sid" element={<TeamMember />} />
              <Route path="/club-overview/:cid" element={<ClubOverview />} />
              <Route path="/player-list" element={<PlayerList />} />
              <Route path="/player-edit/:pid" element={<PlayerEdit />} />
            </Route>

            <Route path="*" element={<Missing />} />
          </Route>
        </Routes>
        <AlertContainer alerts={alerts} />
        {isLoading && <Loading />}
      </BrowserRouter>
    </GlobalContext.Provider>
  );
}
